import { applications, applicationRights } from "../../../api/application_rights";

export default angular
  .module("PermissionService", [])
  .factory("Permissions", [
    function () {
      const hasRole = (user, requiredRole) =>
        user && user.roles && user.roles.indexOf(requiredRole) !== -1;

      const getUserPermissions = user => ({
        admin: hasRole(user, "admin"),
        edit: hasRole(user, "edit"),
        editAlias: hasRole(user, "editAlias"),
        editJs: hasRole(user, "editJs"),
        view: hasRole(user, "view"),
      });

      function getRightLevelsForApplication(application) {
        return applicationRights[application];
      }


      // TODO: When possible, use /api/access_scripts.js functions instead
      const commaSeparatedStringToArray = str =>
        str.split(",").filter(restriction => restriction.length > 0);

      const isLocallyRestrictedScript = nations =>
        nations !== null && nations !== ",0,";

      const scriptNationsMatchToUserNations = (userNations, { NATIONAL_TEAMS }) => {
        if (!isLocallyRestrictedScript(NATIONAL_TEAMS)) {
          return false;
        }

        return !commaSeparatedStringToArray(NATIONAL_TEAMS)
          .some(nation => userNations.indexOf(nation) === -1);
      };

      const providerCheck = (user, script) => {
        if (user.permissions.allProviders) {
          return true;
        }

        return (
          script.CONTENT_PROVIDER !== null &&
          user.permissions.providers.indexOf(script.CONTENT_PROVIDER) !== -1
        );
      };

      const nationalCheck = (user, script) => {
        if (user.permissions.global) {
          return true;
        }

        return (
          script.GLOBAL === "F" &&
          (user.permissions.allNations ||
            scriptNationsMatchToUserNations(user.permissions.nations, script))
        );
      };

      const rightsForScript = (user, script) => {
        const nations = nationalCheck(user, script);
        const providers = providerCheck(user, script);

        return {
          nations,
          providers,
          edit: hasRole(user, "edit") && nations && providers,
        };
      };

      return {
        applications,
        getUserPermissions,
        getRightLevelsForApplication,
        rightsForScript,
      };
    },
  ]);
